<template>
  <div id="expenseTrackingItemComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2">
        <v-flex>
          <v-btn @click="$router.push('/report-ExpenseTracking')" color="primary" outline round><v-icon left>undo</v-icon>{{$t('general.back')}}</v-btn>
        </v-flex>
        <!-- <v-flex class="text-xs-center" offset-sm7>
          <v-btn
            round
            outline
            color="primary"
            dark
            class="text-xs-center"
            @click="downloadZipDialog = true"
          >
            <v-icon left>get_app</v-icon>
            {{$t('general.downloadExpensesFiles')}}
          </v-btn>
        </v-flex> -->
        <v-flex>
          <div v-html="checkExpensesMessage()"></div>
        </v-flex>
      </v-layout>
      <v-layout v-if="expense.id" class="primary pa-2" justify-end>
        <v-flex>
          <h4 class="white--text font-weight-bold mb-0">{{$t('workflowValidation.expense')}} {{expense.id}}</h4>
          <span class="white--text font-weight-bold">"{{expense.description}}"</span>
        </v-flex>
      </v-layout>
      <v-data-table
        class="elevation-2"
        :headers="headers"
        :items="filteredExpenseItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination">
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              :style="header.hidden ? 'display: none;' : ''"
              @click="changeSort(header.value)"
              >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr style="border-bottom: none;">
            <td class="text-sm-center">{{props.item.gst_categories ? props.item.gst_categories.name : '- -'}}</td>
            <td class="text-sm-center d-none">{{props.item.description}}</td>
            <td class="text-sm-center">
              <v-chip color="red" outline v-if="props.item.subtotal === null">
              {{props.item.subtotal | formatCurrency}}
              </v-chip>
              <span v-if="props.item.subtotal !== null"> {{props.item.subtotal | formatCurrency}}</span>
            </td>
            <td class="text-sm-center">{{props.item.discount | formatCurrency}}</td>
            <td class="text-sm-center">
              <v-chip color="red" outline v-if="props.item.total === null">
              {{props.item.total | formatCurrency}}
              </v-chip>
              <span v-if="props.item.total !== null"> {{props.item.total  | formatCurrency}}</span>
            </td>
            <td class="text-sm-center">{{props.item.exchange}}</td>
            <td class="text-sm-center">{{props.item.total_mxn | formatCurrency}}</td>
            <td class="text-sm-center">{{props.item.folio}}</td>
            <td class="text-sm-center">{{props.item.date}}</td>
            <td class="text-sm-center">{{props.item.receipt_type ? props.item.receipt_type.name : '- -'}}</td>
            <td class="text-sm-center">
              <v-layout row justify-center>
                <v-tooltip v-if="props.item.file_attach.length > 0" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="margin-right-05" small icon outline color="primary" v-on="on" @click="attachFiles(props.item)">
                      <v-icon small>attach_file</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.seeMore') }}</span>
                </v-tooltip>
                <span class="" v-if="props.item.receipt_type.id === 2 || props.item.receipt_type.id === 3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="margin-right-05" small icon outline color="primary" v-on="on" @click="viewItems(props.item)">
                      <v-icon small>remove_red_eye</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.seeMore') }}</span>
                </v-tooltip>
              </span>
              <span class="" v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="margin-right-05" small icon outline color="primary" v-on="on" @click="viewItemsF(props.item)">
                      <v-icon small>remove_red_eye</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.seeMore') }}</span>
                </v-tooltip>
              </span>
              </v-layout>
            </td>
          </tr>
          <tr>
            <td colspan="9"><span v-html="props.item.description"></span></td>
          </tr>
        </template>
        <template v-slot:footer>
          <td class="text-xs-center">
            <strong>{{$t('general.totalExpenses')}}</strong>
          </td>
           <td class="text-xs-center">
            <strong>{{currencyFormat(sumaSubtotal)}}</strong>
          </td>
           <td class="text-xs-center">
            <strong>{{currencyFormat(sumaDescuento)}}</strong>
          </td>
          <td class="text-xs-center">
            <strong>{{currencyFormat(sumaTotal)}}</strong>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <!-- Dialog File dialogFile -->
    <v-flex class="text-xs-right">
      <v-dialog persistent v-model="dialogFile" max-width="900px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.attachedFiles')}}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-xs>
                <v-container v-if="loadItem">
                <v-card flat>
                  <v-card-text class="text-center">
                    <v-progress-circular color="primary" size="50" indeterminate/>
                  </v-card-text>
                </v-card>
              </v-container>
              <v-container v-if="!loadItem">
                <template v-if="!$attrs.item">
                  <v-card flat>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs2>
                          <h3> <span class="primary--text font-weight-black"> {{$t('expenseItems.name')}}: </span> #{{editedItemFile.id}} </h3>
                        </v-flex>
                        <v-flex xs7>
                          <h3><span class="primary--text font-weight-black"> {{$t('general.description')}}: </span> {{editedItemFile.description}}</h3>
                        </v-flex>
                        <v-flex xs3>
                          <h3><span class="primary--text font-weight-black"> {{$t('general.category')}}: </span> {{editedItemFile.gst_categories ? editedItemFile.gst_categories.name : ''}}</h3>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-layout>
                    <v-divider/>
                  </v-layout>
                </template>
                <v-layout wrap>
                  <v-flex xs12>
                    <h3 class="primary--text font-weight-black">{{$t('expenses.files')}}:</h3>
                  </v-flex>
                  <v-flex v-if="editedItemFile.file_attach.length > 0">
                    <v-btn v-for="file in editedItemFile.file_attach" :key="file.id" color="primary" dark @click="watchFile(file)">
                      <v-icon left v-if="file.files_type_id === 9 || file.files_type_id === 12">fas fa-file-archive</v-icon>
                      <v-icon left v-else-if="file.files_type_id === 3">description</v-icon>
                      <v-icon left v-else>insert_photo</v-icon>
                      <h3 class="pb-0 mb-0">{{$t('expenses.file')}} {{file.id}}</h3>
                    </v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-alert color="info" outline :value="true" icon="info"> {{$t('expenses.noFiles')}} </v-alert>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-dialog persistent v-model="dialogViewFile" scrollable max-width="900px">
                <v-card>
                  <v-toolbar flat>
                    <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.file') + ': ' + watchItem.id}}</h2>
                  </v-toolbar>
                  <v-card-text class="text-center">
                    <h2 class="text-sm-left primary--text">{{$t('expenses.fileType') + ': ' + fileWatchType}}</h2>
                    <iframe v-if="watchItem.files_type_id === 3 && dataURLFile" :src="dataURL" frameborder="0" width="100%" height="400px" />
                    <zoom-on-hover v-if="dataURLFile && watchItem.files_type_id !== 3" :img-normal="dataURLFile"/>
                    <v-btn color="primary" @click="downloadFile()" :loading="loadBtn" :disabled="loadBtn" v-if="(watchItem.files_type_id === 9 || watchItem.files_type_id === 12) && !loadFile">volver a descargar</v-btn>
                    <v-progress-circular v-if="!dataURLFile && loadFile" color="primary" size="50" indeterminate />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" round flat @click="closeViewFile"> {{ $t('general.cancel') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="closeDialogFiles"> {{ $t('general.close') }}</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-flex>
    <!-- Dialog view item type = No Fiscal Validate-->
    <v-flex class="text-xs-right">
      <v-dialog
        v-model="dialog"
        scrollable
        max-width="800px"
        persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('workflowValidation.item' )}}{{ editedItem.id }} <span> ( {{editedItem.receipt_type ? editedItem.receipt_type.name : ''}} )</span></h2>
            <v-btn class="marginLeft" v-if="editedItem.item_lines.length > 0" round flat color="primary" @click="showEditCategory">
                <v-icon left>list</v-icon> {{ titleTagCategory }}
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="!editCategory">
            <v-form
              lazy-validation
              ref="form"
              v-model="valid">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex layout row wrap v-bind:class="{'xs6': dataURL}">
                  <v-flex xs12>
                    <v-text-field
                      :label="$t('general.date')"
                      disabled
                      prepend-icon="event"
                      v-model="editedItem.date">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.country')"
                      disabled
                      prepend-icon="location_on"
                      v-model="editedItem.country.descripcion">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.category')"
                      disabled
                      prepend-icon="list"
                      v-model="editedItem.gst_categories.name">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      :label="$t('general.description')"
                      disabled
                      prepend-icon="forum"
                      v-model="editedItem.description">
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.currency')"
                      disabled
                      prepend-icon="paid"
                      v-model="editedItem.currency.descripcion">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.exchangeRate')"
                      disabled
                      prepend-icon="currency_exchange"
                      v-model="editedItem.exchange">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 v-if="editedItem.gst_receipt_types_id === 3">
                    <v-text-field
                      :label="$t('general.supplier')"
                      disabled
                      prepend-icon="store"
                      v-model="editedItem.vendor.name"
                    >
                    </v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 md6 v-if="editedItem.gst_receipt_types_id === 3">
                    <v-text-field
                      :label="$t('general.iva')"
                      disabled
                      prepend-icon="percent"
                      v-model="editedItem.foreign_tax.percent"
                    >
                    </v-text-field>
                  </v-flex> -->
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.subtotal')"
                      disabled
                      prepend-icon="attach_money"
                      v-model="editedItem.subtotal">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.total')"
                      disabled
                      prepend-icon="attach_money"
                      v-model="editedItem.total">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.formaPago')"
                      disabled
                      prepend-icon="credit_card"
                      v-model="editedItem.sat_forma_pago.descripcion">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.folioRef')"
                      disabled
                      prepend-icon="article"
                      v-model="editedItem.folio">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      :label="$t('general.comment')"
                      disabled
                      prepend-icon="3p"
                      v-model="editedItem.comment">
                    </v-textarea>
                  </v-flex>
                </v-flex>
                <v-flex xs6 layout v-if="dataURL">
                  <v-flex xs12>
                    <a v-if="!isPDF(dataURL)" @click="openPDF()">
                      <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                    </a>
                    <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                      <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                    </v-btn>
                    <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                  </v-flex>
                </v-flex>
                <h2 class="font-weight-black primary--text mb-0 flex xs12">{{formTitleTip}}</h2>
                <v-form v-if="editedItemTip.created_at !== ''"
                  ref="tipForm"
                  lazy-validation>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItemTip.amount"
                          :error-messages="errors.amount"
                          :rules="rules.required"
                          :label="$t('general.amount')"
                          >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 layout v-if="dataURL">
                        <label>{{$t('expenses.file')}}:</label>
                        <a v-if="!isPDF(dataURL)" @click="openPDF()">
                          <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                        </a>
                        <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                          <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                        </v-btn>
                        <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-layout>
            </v-container>
            </v-form>
          </v-card-text>
          <v-card-text v-if="editCategory">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                        <v-data-table style="width: 100%;" :headers="conceptsHeader" :items="editedItem.item_lines"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="width: 45%">
                                <v-textarea class="text-sm-center dynamic-textarea" rows="1"  auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                              </td>
                              <td style="width: 20%">
                                <v-text-field class="text-sm-center" @input="getTotal(3)" outlined dense :hide-details="true" color="primary" v-model="props.item.amount" type="number" :disabled="true"/>
                              </td>
                              <td style="width: 35%" class="text-sm-center">
                                <v-autocomplete  class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="true"  :rules="rules.required" :items="categories"  color="primary" />
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="close">
              {{$t('general.close')}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="editedItem.file_attach.length > 0"
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="attachDialog = true">
              {{$t('expenses.attachedFiles')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <!-- Dialog view item type=Fiscal Validate-->
    <v-flex class="text-xs-right">
      <v-dialog
        v-model="dialogF"
        scrollable
        max-width="900px"
        persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('workflowValidation.item' )}}{{ editedItemF.id }} <span> ( {{editedItemF.receipt_type ? editedItemF.receipt_type.name : ''}} )</span></h2>
            <v-spacer/>
            <v-btn class="marginLeft" v-if="editedItemF.item_lines.length > 0" round flat color="primary" @click="showEditCategory">
                  <v-icon left>list</v-icon> {{ titleTagCategory }}
                </v-btn>
            <v-btn :disabled="!cfdiHtml" round flat color="primary" @click="sendToPrint()"><v-icon left>print</v-icon> {{$t('general.print')}}</v-btn>
          </v-toolbar>
          <v-card-text v-if="!editCategory">
            <iframe
              name="cfdi"
              :srcdoc="cfdiHtml"
              style="width:845px; height:1200px; border:0">
            </iframe>
              <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.category')"
                      disabled
                      prepend-icon="list"
                      v-model="editedItemF.gst_categories.name">
                    </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :label="$t('general.comment')"
                        disabled
                        prepend-icon="3p"
                        v-model="editedItemF.comment">
                      </v-textarea>
                    </v-flex>
                    <h2 class="font-weight-black primary--text mb-0 flex xs12">{{formTitleTip}}</h2>
                    <v-form v-if="editedItemTip.created_at !== ''"
                      ref="tipForm"
                      lazy-validation>
                      <v-container>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="editedItemTip.amount"
                              :error-messages="errors.amount"
                              :rules="rules.required"
                              :label="$t('general.amount')"
                              >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 layout v-if="dataURL">
                            <v-flex xs12>
                              <label>{{$t('expenses.file')}}:</label>
                              <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                              </a>
                              <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                                <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                              </v-btn>
                              <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                </v-layout>
              </v-container>
          </v-card-text>
          <v-card-text v-if="editCategory">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                        <v-data-table style="width: 100%;" :headers="conceptsHeader" :items="editedItemF.item_lines"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="width: 45%">
                                <v-textarea class="text-sm-center dynamic-textarea" rows="1"  auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                              </td>
                              <td style="width: 20%">
                                <v-text-field class="text-sm-center" @input="getTotal(3)" outlined dense :hide-details="true" color="primary" v-model="props.item.amount" type="number" :disabled="true"/>
                              </td>
                              <td style="width: 35%" class="text-sm-center">
                                <v-autocomplete  class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="true"  :rules="rules.required" :items="categories"  color="primary" />
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="close">
              {{$t('general.close')}}
            </v-btn>
            <v-spacer/>
            <div v-if="editedItemF.receipt_type">
              <v-btn
                color="success darken-1"
                round
                flat
                v-if="editedItemF.receipt_type.id == 1"
                :loading="loadingXML"
                @click="downloadXML('itemF')"
              >
                {{$t('general.downloadXML')}}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-dialog
      v-model="attachDialog"
      persistent
      max-width="50%"
    >
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.attachedFiles')}}</h2>
        </v-toolbar>
        <v-card-text>
          <attach-files-component v-if="editedItem.id" :item="editedItem"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            round
            @click="attachDialog = false"
          >{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import AttachFilesComponent from './attachFiles.component.vue'
export default {
  name: 'expenseTrackingItemComponent',
  components: {
    vueDropzone: vue2Dropzone,
    AttachFilesComponent
  },
  data () {
    return {
      search: null,
      attachDialog: false,
      items: [],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0
      },
      errors: {},
      expense: {},
      expenseItems: [],
      filteredExpenseItems: [],
      editedIndex: -1,
      editedItem: {
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories: {
          name: ''
        },
        gst_categories_id: null,
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 151,
          descripcion: ''
        },
        currency: {
          id: 100,
          descripcion: ''
        },
        sat_forma_pago: {
          descripcion: ''
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        item_lines: [],
        file_attach: []
      },
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: ''
      },
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: ''
      },
      editedItemF: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {
          name: 'name'
        },
        sat_metodo_pago: {},
        validator_comment: '',
        item_lines: [],
        file_attach: []
      },
      defaultItem: {
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories: {
          name: ''
        },
        gst_categories_id: null,
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 0,
          descripcion: ''
        },
        currency: {
          id: 0,
          descripcion: ''
        },
        sat_forma_pago: {
          descripcion: ''
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        item_lines: [],
        file_attach: []
      },
      datemenu: false,
      categories: [],
      satFormaPago: [],
      satMetodoPago: [],
      satMoneda: [],
      satPais: [],
      error: false,
      errorMessage: '',
      date: new Date().toISOString().substr(0, 10),
      sumaSubtotal: 0,
      sumaDescuento: 0,
      sumaTotal: 0,
      loadingItems: true,
      dialog: false,
      loading: false,
      disabled: false,
      dataURL: null,
      valid: true,
      dialogF: false,
      cfdiHtml: null,
      loadingXML: false,
      show: false,
      downloadZipDialog: false,
      selectedZip: null,
      valDownload: true,
      startDate: new Date().toISOString().substr(0, 8) + '01',
      finishDate: new Date().toISOString().substr(0, 10),
      expensesItems: null,
      editCategory: false,
      titleTagCategory: this.$t('general.category'),
      dialogFile: false,
      loadItem: true,
      loadFile: false,
      dataURLFile: null,
      dialogViewFile: false,
      watchItem: {
        files_type_id: 0
      },
      editedItemFile: {
        id: '',
        description: '',
        gst_categories: {
          name: ''
        },
        file_attach: []
      }
    }
  },
  created () {
    this.get()
  },
  computed: {
    setMXN () {
      let item = this.editedItem
      if (item.currency !== undefined && item.currency.id === 100) {
        item.exchange = 1
        return true
      } else {
        return false
      }
    },
    formTitleTip () {
      if (this.editedItemTip.created_at !== '') {
        return this.$t('expenses.tip')
      } else {
        return ''
      }
    },
    heading () {
      return `${this.$t('reportExpenseTracking.name')} / ${this.$t('reportExpenseTracking.seeExpense')}`
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-file-invoice-dollar fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'gst_categories.name',
          sortable: true
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
          hidden: true
        },
        {
          text: this.$t('general.subtotal'),
          align: 'center',
          value: 'subtotal',
          sortable: true
        },
        {
          text: this.$t('general.discount'),
          align: 'center',
          value: 'discount',
          sortable: true
        },
        {
          text: this.$t('general.total'),
          align: 'center',
          value: 'total',
          sortable: true
        },
        {
          text: this.$t('general.exchangeRate'),
          align: 'center',
          value: 'exchange',
          sortable: true
        },
        {
          text: this.$t('general.totalMXN'),
          align: 'center',
          value: 'total_mxn',
          sortable: true
        },
        {
          text: this.$t('general.folioReference'),
          align: 'center',
          value: 'folio',
          sortable: true
        },
        {
          text: this.$t('general.date'),
          align: 'center',
          value: 'date',
          sortable: true
        },
        {
          text: this.$t('general.type'),
          align: 'center',
          value: 'receipt_type.name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'receipt_type.name',
          sortable: true
        }
      ]
    },
    rules () {
      return this.$validationRules()
    },
    expense_id () {
      return this.$route.params.id
    },
    dataArrayFilter () {
      return this.$searchCountry()
    },
    // zipsAvailables () {
    //   if (this.filteredExpenseItems && this.filteredExpenseItems.length > 0) {
    //     let startMonth = this.startDate.substr(5, 2)
    //     let endMonth = this.finishDate.substr(5, 2)
    //     let filtro = this.filteredExpenseItems.filter(item => startMonth && endMonth)
    //     return filtro
    //   }
    // }
    conceptsHeader () {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        }
      ]
    },
    fileWatchType () {
      if (this.watchItem.files_type_id) {
        switch (this.watchItem.files_type_id) {
          case 3:
            return 'pdf'
          case 9:
            return 'rar'
          case 12:
            return 'zip'
          case 5:
            return 'jpeg'
          case 6:
            return 'png'
          default:
            return 'img'
        }
      }
    }
  },
  watch: {
    expense () {
      if (this.expense.start_date !== undefined) {
        this.editedItem.date = this.expense.start_date
      }
    },
    '$route.params.id': function (id) {
      this.get()
    },
    search (val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedItem.country.id, val)
    }
  },
  methods: {
    getTotal () {
      this.editedItem.total = this.editedItem.subtotal
    },
    checkExpensesMessage () {
      var isNull = false
      this.filteredExpenseItems.forEach(item => {
        if (item.subtotal == null) {
          isNull = true
        }
      })
      if (isNull) {
        return `<h5 class="mt-3"><i aria-hidden="true" class="v-icon material-icons theme--light mr-2">warning</i>${this.$t('expenseItems.downloadProcess')}</h5>`
      } else {
        return ``
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    expenseItemsFilter () {
      this.sumaSubtotal = 0
      this.sumaDescuento = 0
      this.sumaTotal = 0
      this.filteredExpenseItems.forEach((value, index) => {
        this.sumaSubtotal += value.subtotal != null ? parseFloat(value.subtotal) : parseFloat(0)
        this.sumaDescuento += value.discount != null ? parseFloat(value.discount) : parseFloat(0)
        this.sumaTotal += value.total != null ? parseFloat(value.total * value.exchange) : parseFloat(0)
      })
    },
    countryFilter (item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Pais.toLowerCase()
      const searchText = queryText.toLowerCase()
      return description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
    },
    currencyFilter (item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
    },
    getSatFormaPago (value) {
      return this.satFormaPago.find(element => element.c_FormaPago === value)
    },
    getSatMetodoPago (value) {
      return this.satMetodoPago.find(element => element.c_MetodoPago === value)
    },
    getCurrency (value) {
      return this.satMoneda.find(element => element.c_Moneda === value)
    },
    getCountry (value) {
      return this.satPais.find(element => element.c_Pais === value)
    },
    get () {
      this.$emit('get', {
        context: this,
        expense_id: this.expense_id
      })
    },
    refresh () {
      this.$emit('refresh', {
        context: this,
        expense_id: this.expense_id
      })
    },
    viewAttach (item) {
      this.$router.push('/expenses/files/watch/' + item.id)
    },
    currencyFormat (val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(val)
    },
    viewItems (items) {
      this.addTip(items)
      this.editedItem = Object.assign({}, items)
      this.editedItem.gst_category_id = this.editedItem.gst_categories.id
      this.dialog = true
      this.loading = false
      this.disabled = false
      items.views = true
      if (items.gst_receipt_types_id === 2 || items.gst_receipt_types_id === 3) {
        if (items.gst_expenses_items_files !== undefined && items.gst_expenses_items_files !== null) {
          if (items.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: items.gst_expenses_items_files[0].files_id
              }
            })
          }
        }
      }
    },
    addTip (item) {
      this.editedItemTip.id = item.id
      this.getTip(item)
    },
    getTip (item) {
      this.$emit('getTip', {
        context: this,
        id: item.id
      })
    },
    getFile (fileId) {
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: fileId
        }
      })
    },
    close () {
      this.loading = false
      this.disabled = false
      this.dialog = false
      this.dataURL = null
      this.editedItemTip = this.defaultItemTip
      this.editedItem = this.defaultItem
      this.editedItemF = this.defaultItem
      this.cfdiHtml = null
      this.dialogF = false
      this.resetCategories()
    },
    isPDF (data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF () {
      var tab = window.open()
      tab.document.write('<body style="margin: 0;"> <iframe src="' + this.dataURL + '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>')
    },
    viewItemsF (items) {
      this.addTip(items)
      if (items.gst_expenses_items_files.length > 0) {
        this.editedItemF = items
        this.$store.dispatch('readXmlToHtml', {
          event: {
            id: items.gst_expenses_items_files[0].files_id,
            context: this,
            type: 'viewItemsF'
          }
        })
      }
      items.views = true
    },
    downloadXML (type) {
      this.loadingXML = true
      this.$store.dispatch('downloadXML', {
        event: {
          context: this,
          fileId: this.editedItemF.gst_expenses_items_files[0].files_id,
          description: this.editedItemF.description
        }
      })
    },
    closeDownloadDialog () {
      this.downloadZipDialog = false
      this.selectedZip = null
    },
    // downloadFiles () {
    //   if (this.$refs.valDownload.validate()) {
    //     this.$store.dispatch('downloadExpensesFiles', {
    //       event: {
    //         context: this,
    //         expensesItems: this.filteredExpenseItems
    //         // date: this.startDate.substr(0, 4)
    //       }
    //     })
    //     this.loading = true
    //   }
    // }
    disableCategories () {},
    showEditCategory () {
      this.editCategory = !this.editCategory
      this.titleTagCategory = !this.editCategory ? this.$t('general.category') : this.$t('general.expense')
    },
    resetCategories () {
      this.editCategory = false
      this.titleTagCategory = this.$t('general.category')
    },
    attachFiles (item) {
      this.dialogFile = true
      this.$emit('getItem', {id: item.id, context: this})
    },
    closeDialogFiles () {
      this.dialogFile = false
      this.loadItem = true
      this.loadFile = false
      this.dataURLFile = null
      this.dialogViewFile = false
    },
    closeViewFile () {
      this.dialogViewFile = false
      this.loadFile = false
      this.dataURLFile = null
    },
    watchFile (item) {
      this.dialogViewFile = true
      this.watchItem = item
      this.loadFile = true
      if (item.files_type_id === 9 || item.files_type_id === 12) {
        this.$store.dispatch('getZip', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      } else {
        this.$store.dispatch('getFile', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      }
    },
    downloadFile () {
      this.loadBtn = true
      this.$store.dispatch('getZip', {
        event: {
          context: this,
          fileId: this.watchItem.id
        }
      })
    }
  }
}
</script>
<style>
table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px;
}

.margin-right-05 {
  margin-right: 0.5px;
}

.marginLeft{
  margin-left: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/expenseTracking.item.component.vue